import React from 'react';
import styles from 'apps/offer/NegotiateOffer/EarlyRepaymentCalculator/EarlyRepaymentCalculator.module.scss';

export default {
  settleInFull: 'If your client settles in full at',
  scale: 'months',
  totalRepaymentAndSavings: ({ totalRepayment, totalSaving }) => (
    <>
      their total repayment would be{' '}
      <span className={styles.boldValue} data-testid='repayment'>
        {totalRepayment}
      </span>{' '}
      and they would save{' '}
      <span className={styles.boldValue} data-testid='saving'>
        {totalSaving}
      </span>
    </>
  )
};
